import { createSlice } from '@reduxjs/toolkit';

const robotConfigSlice = createSlice({
  name: 'robotConfig',
  initialState: {
    config: {
      botName: '', // 智能体名称
      llmModel: 0, // llm code
      examMsg: [], // 猜你想问
      firstMsg: '', // 欢迎语
      supportFile: 0, // 是否支持文件上传
      whetherPredict: 0, // 是否开启预测问题 0 不预测 1 预测
      supportPicture: 0, // 是否支持图片上传
      isDisplaySource: 0, // 是否展示来源 0 不展示 1 展示
      openVoice: 0, // 是否开启语音播放
      developerMode: 0, // 是否开启开发者模式 0 关闭 1 开启
      questionTemplate: [], // 快捷指令
      payInfo: {} // 付费信息
    }
  },
  reducers: {
    setRobotConfig (state, { payload }) {
      const data = {
        ...payload,
        examMsg: payload.examMsg?.sort((a: string, b: string) => a?.length - b?.length)
      };
      state.config = data;
    }
  }
});

export const { setRobotConfig } = robotConfigSlice.actions;
export default robotConfigSlice.reducer;
